"use strict";
define(
    'stores/boards',[
        "jquery",
        "underscore",
        "stores/store",
        "actions/boards",
        "constants/actiontypes",
        "shared/user",
        "xregexp"
    ],
    function ($, _, StoreBase, Action, Constants, User, XRegExp)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;

        function Store (params)
        {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.boards = {};

            this.registerDispatchListener(function (action) {
                switch(action.actionType) {
                    case Constants.CREATE_BOARD:
                        if (Array.isArray(action.data)) {
                            _.each(action.data, function (data, index, list) {
                                this.addBoard(data);
                            }, this);
                        } else {
                            this.addBoard(action.data);
                        }
                        this.event.emit("change");
                        break;
                    case Constants.DELETE_BOARD:
                        if (Array.isArray(action.data)) {
                            _.each(action.data, function (data, index, list) {
                                this.removeBoard(data);
                            }, this);
                        } else {
                            this.removeBoard(action.data);
                        }
                        this.event.emit("change");
                        break;
                }
            }.bind(this));

            this.action = new Action();
        }

        Store.prototype.addBoard = function(data)
        {
            if(this.boards[data.id.toLowerCase()]) {
                delete this.boards[data.id.toLowerCase()];
            }
            
            data.created_at = new Date(data.created_at);
            data.updated_at = new Date(data.updated_at);
            this.boards[data.id.toLowerCase()] = data;
        };

        Store.prototype.removeBoard = function(data) {
            if(this.boards[data.guid]) {
                delete this.boards[data.guid];
            }
        }

        Store.prototype.sort = function(items) {
            // After sorting we also filter by the currently logged in users guid since the dashboard doesn't need those boards
            items.sort(function(a, b) {
                var a_updatedAt = new Date(a.updated_at).getTime();
                var b_updatedAt = new Date(b.updated_at).getTime();

                if(a_updatedAt > b_updatedAt)
                    return -1;
                else if(a_updatedAt < b_updatedAt)
                    return 1;
                return 0;
            });
            return items.filter(function(board) {
                return (board.owner_guid == User.getProperty('guid'));
            });
        }

        Store.prototype.getAll = function()
        {
            if(Object.values) {
                return this.sort(Object.values(this.boards));
            } else {
                var self = this;
                return Object.keys(this.boards).map(function(key) {
                    return self.boards[key];
                });
            }
        };

        Store.prototype.getBoardCount = function()
        {
            return _.size(this.boards);
        };

        Store.prototype.hasBoard = function(id)
        {
            return (id.toLowerCase() in this.boards);
        };

        Store.prototype.hasBoardPins = function(id) {
            return (id.toLowerCase() in this.boards) && typeof this.boards[id.toLowerCase()].pins !== "undefined";
        }

        Store.prototype.getBoard = function(id)
        {
            if(id && this.boards[id.toLowerCase()])
                return this.boards[id.toLowerCase()];
            return null;
        };
        Store.prototype.filterByKeyword = function(keyword) {
            // Trim all spaces from beginning and ending
            keyword = keyword.trim();

            // Make a regular expression to allow all characters, numerics, and spaces
            var allowCharacterSets = XRegExp("[^\\pL\\s\\d]+", "g");

            // Replace all special characters as nothing and space as OR("|")
            keyword = XRegExp.replace(keyword, allowCharacterSets, "");
            keyword = keyword.trim().replace(/\s+/g, "|");

            // Make a regular expression to search with keyword
            var regExp = new RegExp(keyword, "i");

            var filtered = [];
            _.each(this.boards, function(item) {
                if(regExp.test(item.title))
                    filtered.push(item);
            });

            return filtered;
        }


        Store.prototype.getBoards = function(ids)
        {
            var filtered = {};
            for(var i = 0; i < ids.length; i++) {
                if(this.boards[ids[i].toLowerCase()]) {
                    filtered[ids[i]] = this.boards[ids[i].toLowerCase()];
                }
            }

            return filtered;
        };
        return Store;
    }
);

